define(function (require) {

    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var AcWrapper = require('web-agent-utils/AcWrapper');
    var BaseApiService = require('web-agent-utils/BaseApiService');
    var LEConfig = require("assets/config/le-env-conf");

    lpTag.Operators = function () {

        this.POLLING_TIME_IN_SEC = 60;
        this.SERVICE_NAME = {
            USER_MANAGEMENT: "Operators",
            ACCOUNT_CONFIG: lpTag.WebAgent.logicController.hasProfileFeature() ? "UsersWithProfiles" : "Users"
        };

        this.applicationType = "Operators";

        this.logger = WebAgentLogger.getLogger(this.applicationType);

        this._initApi();
    };

    lpTag.Operators.prototype = {

        _initApi: function () {
            if (lpTag.WebAgent.logicController.isAccountConfigUsersEnabled()) {
                this._initAccountConfigApi();
            } else {
                this._initAppServerApi();
            }
        },

        _initAccountConfigApi: function () {
            this.logger.info('initializing operators API instance for LE2 environment', '_initAccountConfigApi');

            var operatorsApiInstance;
            var accountConfigApiResource;

            accountConfigApiResource = agentLEManager.getLEUrlResolverApiResourcesService("AccountConfig");
            if (!accountConfigApiResource || !accountConfigApiResource[this.SERVICE_NAME.ACCOUNT_CONFIG]) {
                this.logger.error('failed to create account config API resource, or API resource does not contain the ' +
                    'requested service, aborting initialization', '_initAccountConfigApi');
                return;
            }

            operatorsApiInstance = AcWrapper.createInstance(
                accountConfigApiResource[this.SERVICE_NAME.ACCOUNT_CONFIG], this.SERVICE_NAME.ACCOUNT_CONFIG);
            if (!operatorsApiInstance) {
                this.logger.error('failed to create account config API instance, aborting initialization', '_initAccountConfigApi');
                return;
            }

            this.getOperators = function (reqObj) {
                var includeDeleted = !!LEConfig.supportDeletedUsers;
                operatorsApiInstance.getValue({
                    success: reqObj.success,
                    error: reqObj.error,
                    data: {
                        include_deleted: includeDeleted
                    },
                    query: "select=id,pid,deleted,loginName,nickname,fullName,skillIds,memberOf(agentGroupId)"
                });
            };
        },

        _initAppServerApi: function () {
            this.logger.info('initializing operators API instance for legacy environment', '_initAppServerApi');

            var operatorsApiInstance;
            var userManagementApiResource;
            var userManagementUrl;

            userManagementApiResource = agentLEManager.getLEUrlResolverApiResourcesService("UserManagement");

            if (!userManagementApiResource) {
                this.logger.error('failed to create user management API resource, aborting initialization', '_initAppServerApi');
                return;
            }

            if (!userManagementApiResource[this.SERVICE_NAME.USER_MANAGEMENT] ||
                !userManagementApiResource[this.SERVICE_NAME.USER_MANAGEMENT].url) {
                this.logger.error('API resource does not contain the requested service, or API resource service is ' +
                    'missing the URL, aborting initialization', '_initAppServerApi', userManagementApiResource);
                return;
            }

            userManagementUrl = agentLEManager.getLEUrlResolverGetUrl(
                userManagementApiResource[this.SERVICE_NAME.USER_MANAGEMENT].url);

            if (!userManagementUrl) {
                this.logger.error('failed to resolve API resource URL, aborting initialization');
                return;
            }

            operatorsApiInstance = BaseApiService.createInstance({
                domainUrl: userManagementUrl,
                postmessagePath: "/postmessage",
                serviceName: this.SERVICE_NAME.USER_MANAGEMENT
            });

            if (!operatorsApiInstance) {
                this.logger.error('failed to create user management API instance, aborting initialization', '_initAppServerApi');
                return;
            }

            this.getOperators = function (reqObj) {
                reqObj.callingFunction = 'getOperators';
                reqObj.method = 'GET';
                reqObj.pollingTimeout = 1000 * this.POLLING_TIME_IN_SEC;
                operatorsApiInstance.startPolling(reqObj);
            };

            this.stopPolling = function () {
                operatorsApiInstance.stopPolling();
            };
        }
    };

    return lpTag.Operators;

});
